















import { authService } from '@/services/AuthenticationService';
import { IWorker } from '@/services/WorkerService';
import { Getter, Getters, Mutations } from '@/store';
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class Profile extends Vue {

  @Getter(Getters.ID_TOKEN)
  private idToken!: string;

  @Getter(Getters.PROFILE)
  private profile: any;

  @Getter(Getters.WORKER)
  private worker!: IWorker;

  public created() {
    const auth = authService.authenticationDetails();
    if (auth !== null) {
      this.$store.commit(Mutations.LOGIN, auth);
    }
  }

  private login() {
    authService.login();
  }

  private logout() {
    authService.logout();
  }
}
